import { useFormContext } from "react-hook-form";
import { Button, Collapse } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const EditCollapsableActions = ({
  shouldCollapseIn,
  cancelEdit,
  isDisabled,
  updateLoader,
  handleUpdateLead
}) => {
  const { t } = useTranslation();
  const { handleSubmit } = useFormContext();
  return (
    <Collapse in={shouldCollapseIn}>
      <div>
        <div className="mt-3 text-end">
          <Button className="me-2" variant="secondary" onClick={cancelEdit}>
            {t("common.cancel")}
          </Button>
          <Button
            type="button"
            disabled={isDisabled}
            onClick={handleSubmit(handleUpdateLead)}
          >
            {`${t("common.update")}${updateLoader ? "..." : ""}`}
          </Button>
        </div>
      </div>
    </Collapse>
  );
};
export default EditCollapsableActions;
